/* eslint-disable @next/next/no-img-element */

import Image from "next/image";
import cn from "clsx";
import React from "react";

import type {
  ArticleStyle,
  Image as ContentImage,
} from "../../../types/content";

import styles from "./TeaserImage.module.scss";
import {
  getResponsiveFeedImageAttributes,
  sizeNameToSizeValues,
} from "../../../utils/image";
import { getImageSizes } from "../../ArticleContent/resources/Url/utils";

interface TeaserImageProps {
  imageUrl?: string;
  image?: ContentImage;
  size: "small" | "large";
  style: ArticleStyle;
  alt?: string;
  hasPriorityImage?: boolean;
  isVideo?: boolean;
}

const TeaserImage = ({
  imageUrl,
  image,
  size,
  style,
  alt,
  hasPriorityImage,
  isVideo = false,
}: TeaserImageProps) => {
  if (!imageUrl) {
    return null;
  }

  const imgProps = sizeNameToSizeValues[size];
  const responsiveAttributes = image
    ? getResponsiveFeedImageAttributes({
        size,
        sizes:
          size === "small"
            ? getImageSizes({ web: "120px", tablet: "100px" })
            : getImageSizes({ web: "688px", tablet: "100vw" }),
        useFallback: true,
        image,
      })
    : null;

  return (
    <div
      className={cn([
        styles.teaserImage,
        styles[size],
        styles[style],
        isVideo && styles.videoContainer,
      ])}
    >
      {/* next/image cannot emit srcset here because global images.unoptimized is enabled */}
      <img
        src={responsiveAttributes?.src || imageUrl}
        srcSet={responsiveAttributes?.srcSet}
        sizes={responsiveAttributes?.sizes}
        width={responsiveAttributes?.width || imgProps.width}
        height={responsiveAttributes?.height || imgProps.height}
        alt={alt || ""}
        loading={hasPriorityImage ? "eager" : "lazy"}
        fetchPriority={hasPriorityImage ? "high" : undefined}
        decoding="async"
      />
      {isVideo && (
        <Image
          className={styles.videoIcon}
          data-testid="videoPlayButton"
          alt=""
          height={10}
          width={10}
          src={`${process.env.NEXT_PUBLIC_ASSET_PREFIX || ""}/images/playbtn.png`}
        />
      )}
    </div>
  );
};

export { TeaserImage };
